import { render, staticRenderFns } from "./SettingNav.vue?vue&type=template&id=1269d428&scoped=true&"
import script from "./SettingNav.vue?vue&type=script&lang=js&"
export * from "./SettingNav.vue?vue&type=script&lang=js&"
import style0 from "./SettingNav.vue?vue&type=style&index=0&id=1269d428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269d428",
  null
  
)

export default component.exports